import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: [],
  },
  getters: {
    list: (state) => state.list,
  },
  actions: {
    fetch({ commit, dispatch }) {
      return ajax.get("ProductManagement/api/SpecificProductsQuery");
    },
    fetchFullSearch({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .get("ProductManagement/api/SpecificProductsQuery?" + model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    listSpecificProductPerContract(
      { commit, dispatch },
      deductionAndIncreaseId
    ) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Sales/api/SpecificProductDeductionAndIncreasesQuery/Specific-products-Info-of-contract/" +
              deductionAndIncreaseId
          )
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    create({ commit, dispatch }, model) {
      return ajax.post("ProductManagement/api/SpecificProducts", model);
    },
    remove({ commit, dispatch }, id) {
      return ajax.delete(
        "ProductManagement/api/SpecificProducts",
        { data: { id: id } },
        { headers: { "Content-Type": "application/json" } }
      );
    },
    update({ commit, dispatch }, model) {
      return ajax.put("ProductManagement/api/SpecificProducts", model);
    },
    updatePrice({ commit, dispatch }, model) {
      return ajax.patch(
        "Sales/api/ContractProductsInfo/price/manually-update",
        model
      );
    },
    assignItemInfo({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Sales/api/SpecificProductDeductionAndIncreases/add", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },

    unAssignItemInfo({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .put("Sales/api/SpecificProductDeductionAndIncreases/remove", model)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e.response.data);
          });
      });
    },
    AutomatePrice({ commit, dispatch }, model) {
      return ajax.patch(
        "Sales/api/ContractProductsInfo/price/automatic-update",
        model
      );
    },
    fetchSearch({ commit, dispatch }, name) {
      return new Promise((resolve, reject) => {
        ajax
          .get("ProductManagement/api/SpecificProductsQuery/" + name)
          .then((r) => {
            resolve(r.data);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    },
  },
};
